import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useScoreProjectDialogStyles = makeStyles({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
    minWidth: "400px",
  },
  infoSection: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
  warningBox: {
    borderRadius: designTokens.borderRadius.md,
    marginTop: designTokens.spacing[2],
  },
  warningList: {
    margin: `${designTokens.spacing[2]} 0`,
    paddingLeft: designTokens.spacing[4],
  },
  progressSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: designTokens.spacing[4],
    padding: designTokens.spacing[6],
  },
  statusHeader: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  progressBar: {
    width: "100%",
  },
  progressText: {
    color: designTokens.neutral[500],
  },
  completedSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: designTokens.spacing[6],
    textAlign: "center",
  },
  successColor: {
    color: designTokens.semantic.success,
  },
  errorSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: designTokens.spacing[2],
    padding: designTokens.spacing[6],
    textAlign: "center",
  },
  errorColor: {
    color: designTokens.semantic.error,
  },
});
